// extracted by mini-css-extract-plugin
export var component = "TextModule-module--component--cMBqv";
export var content = "TextModule-module--content--66vY9";
export var info = "TextModule-module--info--Xx+Uw";